import React from 'react';

const CartPlusIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6001 0.600098L2.3201 3.0001M2.3201 3.0001L5.2001 12.6001H18.4001V5.4001C18.4001 4.07461 17.3256 3.0001 16.0001 3.0001H2.3201ZM11.2001 4.8001V10.8001M8.2001 7.8001H14.2001M16.0001 17.4001C15.3374 17.4001 14.8001 16.8628 14.8001 16.2001C14.8001 15.5374 15.3374 15.0001 16.0001 15.0001C16.6628 15.0001 17.2001 15.5374 17.2001 16.2001C17.2001 16.8628 16.6628 17.4001 16.0001 17.4001ZM6.4001 16.2001C6.4001 15.5374 6.93736 15.0001 7.6001 15.0001C8.26284 15.0001 8.8001 15.5374 8.8001 16.2001C8.8001 16.8628 8.26284 17.4001 7.6001 17.4001C6.93736 17.4001 6.4001 16.8628 6.4001 16.2001Z"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  );
};

export default CartPlusIcon;
